@let control = $control();
<unity-control-wrapper [control]="control" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  @let showSpinners = $spinners() && control && control.enabled;
  <kendo-numerictextbox format="##" [min]="0" [spinners]="showSpinners" [step]="$spinnerStep()" [formControl]="control" />
</unity-control-wrapper>
